import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import colors from "@constants/color";
import KYCFailed from "../../assets/svg/KYCSetup/KYCStatus/Failed";
import KYCPartiallySuccess from "../../assets/svg/KYCSetup/KYCStatus/PartiallySuccess";
import KYCProcessing from "../../assets/svg/KYCSetup/KYCStatus/Processing";
import KYCSuccess from "../../assets/svg/KYCSetup/KYCStatus/Success";

const KYCStatus = (props) => {
  const { statusText = "NONE", isAadharPanLinked = false } = props;

  const [data, setData] = useState({
    icon: null,
    bgColor: "white",
    borderColor: "white",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    switch (statusText) {
      case "NONE":
        setData({
          icon: null,
          bgColor: "white",
          borderColor: "white",
          title: "",
          subTitle: "",
        });
        break;
      case "PROCESSING":
        setData({
          icon: KYCProcessing,
          bgColor: "rgba(49,106,190,0.05)",
          borderColor: "rgba(49,106,190,1)",
          title: "वेरिफिकेशन प्रोसेस में है",
          subTitle: "आपका वेरिफिकेशन अभी प्रोसेस में है I",
        });
        break;
      case "REJECTED":
        setData({
          icon: KYCFailed,
          bgColor: "rgba(255,0,0,0.05)",
          borderColor: colors.primary,
          title: "वेरिफिकेशन फेल्ड",
          subTitle: !isAadharPanLinked
            ? "आपका वेरिफिकेशन फेल हो गया है I आपका आधार \nऔर पैन लिंक नहीं है, कृपया अपने डाक्यूमेंट्स फिर से डालें I"
            : "आपका वेरिफिकेशन फेल हो गया है I कृपया अपने डाक्यूमेंट्स फिर से डालें I",
        });
        break;
      case "VERIFIED":
        setData({
          icon: KYCSuccess,
          bgColor: "rgba(49,106,190,0.05)",
          borderColor: "rgba(49,106,190,1)",
          title: "Congratulations !",
          subTitle: "आपका KYC वेरिफाइड हो चुका है",
        });
        break;
      case "PARTIALLY_VERIFIED":
        setData({
          icon: KYCPartiallySuccess,
          bgColor: "rgba(0,0,0,0.05)",
          borderColor: "rgb(0,171,89,1)",
          title: "केवल कुछ डाक्यूमेंट्स वेरिफाइड हुए",
          subTitle:
            "जिन डाक्यूमेंट्स का वेरिफिकेशन फेल हो गया है, उनको फिर से अपलोड करें I",
        });
        break;
    }
  }, [statusText, isAadharPanLinked]);

  const { icon: Icon } = data;
  return data?.icon ? (
    <View
      style={{
        marginVertical: 10,
        borderWidth: 1,
        borderColor: data.borderColor,
        backgroundColor: data.bgColor,
        flexDirection: "row",
        alignItems: "center",
        borderRadius: 10,
        paddingVertical: 2,
      }}
    >
      <View style={{ padding: 6 }}>
        <Icon />
      </View>
      <View style={{ marginLeft: 4, width: "100%", flexShrink: 1 }}>
        <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}>
          {data?.title}
        </Text>
        <Text>{data?.subTitle}</Text>
      </View>
    </View>
  ) : null;
};

export default KYCStatus;
